const enUS = {
  common: {
    welcome: 'Welcome to WYNI AI ERP',
    login: 'Login',
    email: 'Email',
    password: 'Password',
    dashboard: 'Dashboard',
    users: 'User Management',
    products: 'Product Management',
    orders: 'Order Management',
    reports: 'Reports',
    settings: 'Settings',
    revenue: 'Revenue',
    // Additional translations
    search: 'Search',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    back: 'Back',
    loading: 'Loading...',
    noData: 'No Data',
    error: 'Error',
    success: 'Success',
  },
  auth: {
    login_success: 'Login successful',
    login_failed: 'Login failed',
    logout_success: 'Logout successful',
  },
};

export default enUS; 